import { Progress } from '@/components/ui/progress';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function RotationsplanProgress({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const { t } = useTranslation();
  const percentage =
    (rotationsplan.getAbgeschlosseneStationen().length * 100) /
    rotationsplan.getAmountOfStationen();

  const alleStationen = rotationsplan.getAllStationen();

  const firstStation = alleStationen[0];
  const lastStation = alleStationen[alleStationen.length - 1];

  return (
    <div className="flex justify-between items-center gap-4">
      <div className="flex items-center gap-2 w-full md:w-1/2">
        <Progress value={percentage} className=" bg-neutrals-300 h-2" />
        <div className="hidden md:flex text-sm text-neutrals-800 whitespace-nowrap">
          {alleStationen.length > 0
            ? t('domain.mitarbeiter.rotationsplan.rotationsplaene.progress', {
                abgeschlossen:
                  rotationsplan.getAbgeschlosseneStationen().length,
                alleStationen: alleStationen.length,
              })
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </div>
        <div className="flex md:hidden text-sm text-neutrals-800 whitespace-nowrap">
          {alleStationen.length > 0
            ? `${rotationsplan.getAbgeschlosseneStationen().length} / ${rotationsplan.getAmountOfStationen()}`
            : t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keineStationen',
              )}
        </div>
      </div>
      {alleStationen.length > 0 && (
        <div className="flex items-center gap-1 text-neutrals-800 text-sm whitespace-nowrap">
          <FontAwesomeIcon icon={faGraduationCap} />
          {`${dayjs(firstStation.von).format('MMM YYYY')} – ${dayjs(lastStation.bis).format('MMM YYYY')}`}
        </div>
      )}
    </div>
  );
}
